import { Box } from "@mui/system";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useState } from "react";
type CommonDataGridTableProps = {
  rows: any[];
  columns: any[];
};

const CommonDataGridTable = ({ rows, columns }: CommonDataGridTableProps) => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  return (
    <Box sx={{ width: "100%", display: "grid", mt: 1 }}>
      <DataGridPro
        sx={dataGridStyles}
        density="compact"
        pagination
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[10, 25, 100]}
        rows={rows}
        columns={columns}
        disableColumnMenu
        disableColumnFilter
        disableColumnReorder
        getRowId={(row) => row.id}
        localeText={{
          noRowsLabel: "No data available",
        }}
        sortingOrder={["asc", "desc"]}
        isCellEditable={() => false}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default CommonDataGridTable;

// === Shared DataGrid Styles ===
const dataGridStyles = {
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
    { outline: "none" },
  "& .MuiDataGrid-cellEmpty": {
    width: "auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .MuiDataGrid-row.Mui-selected": {
    backgroundColor: "rgba(156, 39, 176, 0.08) !important",
    "&:hover": { backgroundColor: "rgba(156, 39, 176, 0.16) !important" },
  },
  "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
    backgroundColor: "#f0def3 !important",
  },
  "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft": {
    backgroundColor: "#e6d6e9ff !important",
  },
  "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight": {
    backgroundColor: "#f0def3 !important",
  },
  "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight": {
    backgroundColor: "#e6d6e9ff !important",
  },
  "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight": {
    backgroundColor: "#ffffff",
  },
  "& .MuiDataGrid-cell.Mui-selected": { backgroundColor: "inherit !important" },
  "& .MuiCheckbox-root": { color: "#9c27b0 !important" },
  "& .MuiCheckbox-root.Mui-checked": { color: "#9c27b0" },
  border: "none",
};
